import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HydratorError = /*#__PURE__*/function (_Error) {
  function HydratorError(_ref) {
    var _this;
    var error = _ref.error,
      message = _ref.message;
    _classCallCheck(this, HydratorError);
    _this = _callSuper(this, HydratorError);
    var err = error instanceof Error ? error : new Error();
    _this.name = 'HydratorError';
    _this.message = message;
    _this.originalMessage = err.message;
    _this.stack = err.stack;
    _this.originalName = err.name;
    return _this;
  }
  _inherits(HydratorError, _Error);
  return _createClass(HydratorError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { HydratorError as default };